import { RouteProps } from 'react-router-dom';
import { authPagesMenu } from '../menu';
// import DefaultHeader from '../pages/_layout/_headers/DefaultHeader';

/**
 * Header 路由配置
 * 暂时禁用 Header
 */

const headers: RouteProps[] = [
  // Auth pages - no header
  { path: authPagesMenu.login.path, element: null },
  { path: authPagesMenu.page404.path, element: null },

  // All pages - header disabled
  {
    path: `*`,
    element: null,
  },
];

export default headers;
